"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardiaAppointment = void 0;
class GuardiaAppointment {
    constructor(props) {
        this.appointment_data = props?.appointment_data || null;
        this.assignation_id = props?.assignation_id || null;
        this.cm = props?.cm || null;
        this.country = props?.country || null;
        this.cuil = props?.cuil || null;
        this.cuit = props?.cuit || null;
        this.date = props?.date || null;
        this.datetime = props?.datetime || null;
        this.especialidad = props?.especialidad || null;
        this.fullname = props?.fullname || null;
        this.id = props?.id || null;
        this.max_appointments = props?.max_appointments || null;
        this.path_profile_pic = props?.path_profile_pic || null;
        this.patient = props?.patient || null;
        this.payment_data = props?.payment_data || null;
        this.provider = props?.provider || null;
        this.slots = props?.slots || null;
        this.social_work = props?.social_work || null;
        this.state = props?.state || null;
        this.time = props?.time || null;
        this.timestamps = props?.timestamps;
        this.documentReferences = props?.documentReferences || [];
        this.uid = props?.uid || null;
        this.room = props?.room || "";
        this.token = props?.token || "";
        this.vip = props?.vip || false;
        this.score = props?.score || 0;
        this.affiliateNumber = props?.affiliateNumber || "";
        this.affiliateType = props?.affiliateType || "";
        this.preliminar_patient_medication = props?.preliminar_patient_medication || null;
    }
}
exports.GuardiaAppointment = GuardiaAppointment;
